module.exports = __webpack_public_path__ + "fonts/ClearSans-Regular-webfont9e20807d57018e317ba0ada46a938e40.svg";